import { requestData, receiveData, receiveError } from '../../api/http'
import CloudFlyerAPI from '../../api/CloudFlyerAPI'

export const FETCH_DESKTOP_PROFILE_PENDING = 'FETCH_DESKTOP_PROFILE_PENDING'
export const FETCH_DESKTOP_PROFILE_SUCCESS = 'FETCH_DESKTOP_PROFILE_SUCCESS'
export const FETCH_DESKTOP_PROFILE_ERROR = 'FETCH_DESKTOP_PROFILE_ERROR'

export const LOGIN_DESKTOP_PENDING = 'LOGIN_DESKTOP_PENDING'
export const LOGIN_DESKTOP_SUCCESS = 'LOGIN_DESKTOP_SUCCESS'
export const LOGIN_DESKTOP_ERROR = 'LOGIN_DESKTOP_ERROR'

export const LOGOUT_DESKTOP_PENDING = 'LOGOUT_DESKTOP_PENDING'
export const LOGOUT_DESKTOP_SUCCESS = 'LOGOUT_DESKTOP_SUCCESS'
export const LOGOUT_DESKTOP_ERROR = 'LOGOUT_DESKTOP_ERROR'

export const REGISTER_DESKTOP_PENDING = 'REGISTER_DESKTOP_PENDING'
export const REGISTER_DESKTOP_SUCCESS = 'REGISTER_DESKTOP_SUCCESS'
export const REGISTER_DESKTOP_ERROR = 'REGISTER_DESKTOP_ERROR'

export const EDIT_DESKTOP_CURRENT_USER = 'EDIT_DESKTOP_CURRENT_USER'

export const RESEND_DESKTOP_VERIFICATION_EMAIL_PENDING =
  'RESEND_DESKTOP_VERIFICATION_EMAIL_PENDING'
export const RESEND_DESKTOP_VERIFICATION_EMAIL_SUCCESS =
  'RESEND_DESKTOP_VERIFICATION_EMAIL_SUCCESS'
export const RESEND_DESKTOP_VERIFICATION_EMAIL_ERROR =
  'RESEND_VERIFICATION_EMAIL_ERROR'

export const NAV_DESKTOP = 'NAV_DESKTOP'

export const REFRESH_DESKTOP_RM = 'REFRESH_DESKTOP_RM'

export function login(email, password) {
  return dispatch => {
    dispatch(requestData(LOGIN_DESKTOP_PENDING))

    CloudFlyerAPI.desktop_partner
      .login({
        Username: email,
        Password: password,
      })
      .then(function(response) {
        dispatch(receiveData(LOGIN_DESKTOP_SUCCESS, (response || {}).data))
      })
      .catch(function(err) {
        dispatch(receiveError(LOGIN_DESKTOP_ERROR, err))
      })
  }
}

export function refresh_profile(refresh) {
  return dispatch => {
    dispatch(requestData(FETCH_DESKTOP_PROFILE_PENDING))

    let user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      return dispatch(receiveData(FETCH_DESKTOP_PROFILE_SUCCESS, user))
    }
  }
}

export function logout() {
  return dispatch => {
    dispatch(requestData(LOGOUT_DESKTOP_PENDING))

    CloudFlyerAPI.user_account.logout()
    dispatch(receiveData(LOGOUT_DESKTOP_SUCCESS, {}))
  }
}

export function register(account) {
  return dispatch => {
    dispatch(requestData(REGISTER_DESKTOP_PENDING))

    CloudFlyerAPI.user_account
      .register(account)
      .then(response =>
        dispatch(
          receiveData(REGISTER_DESKTOP_SUCCESS, {
            ...(response || {}).data,
            email: account.email,
          })
        )
      )
      .catch(err => dispatch(receiveError(REGISTER_DESKTOP_ERROR, err)))
  }
}

export function update_user(data) {
  return dispatch => {
    CloudFlyerAPI.user_account
      .update(data)
      .then(() => dispatch(editCurrentUser(data)))
  }
}

export function editCurrentUser(data) {
  return {
    type: EDIT_DESKTOP_CURRENT_USER,
    data,
  }
}

export function resendVerificationEmail(data) {
  return dispatch => {
    dispatch(requestData(RESEND_DESKTOP_VERIFICATION_EMAIL_PENDING))
    CloudFlyerAPI.user_account
      .resend_verification_email(data)
      .then(response => {
        dispatch(
          receiveData(
            RESEND_DESKTOP_VERIFICATION_EMAIL_SUCCESS,
            (response || {}).data
          )
        )
      })
      .catch(err => {
        dispatch(receiveError(RESEND_DESKTOP_VERIFICATION_EMAIL_ERROR, err))
      })
  }
}

// export const refresh_rm = () => {
//   return {
//     type: REFRESH_DESKTOP_RM,
//   }
// }
